import { LoginForm } from './login-form/LoginForm'
import { useLogin } from './login-form/useLogin'
import { AuthTopNavigation } from '../auth-top-navigation/AuthTopNavigation'
import { LoginInfoSection } from './login-info/LoginInfo'
import { LoginFormTwoFa } from './login-form/LoginFormTwoFa'

function LoginPage() {
  const {
    loginTwoFaCodeExpiresAt,
    loginStep,
    handleReset,
    loginUserMutation,
    isLoginRequesting,
    loginUserError,
    handleResendLoginTwoFaCode,
    setLoginCreds,
    loginUserTwoFaMutation,
    isLoginTwoFaRequesting,
    loginUserTwoFaError,
  } = useLogin()

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="flex items-start col-span-1">
        <div className="flex flex-col justify-center items-center gap-0 lg:gap-[60px] w-full">
          <AuthTopNavigation />
          <div className="flex flex-col gap-10 lg:gap-6 w-full lg:w-[400px] md:px-5 lg:px-0 lg:py-auto pb-10 lg:pb-20">
            {loginStep === 'credentials' && (
              <LoginForm
                isRequesting={isLoginRequesting}
                handleSubmitForm={(creds) => {
                  setLoginCreds(creds)
                  loginUserMutation(creds)
                }}
                error={loginUserError}
              />
            )}

            {loginStep === 'twoFa' && (
              <LoginFormTwoFa
                twoFaCodeExpiresAt={loginTwoFaCodeExpiresAt}
                isRequesting={isLoginTwoFaRequesting}
                error={loginUserTwoFaError}
                handleSubmitForm={loginUserTwoFaMutation}
                handleResendLoginTwoFaCode={handleResendLoginTwoFaCode}
                handleGoBack={handleReset}
              />
            )}
          </div>
        </div>
      </div>

      <div className="hidden lg:flex lg:col-span-1 justify-center items-center md:px-20 bg-foreground text-primary-foreground">
        <LoginInfoSection />
      </div>
    </div>
  )
}

export default LoginPage
